import { Module } from "wrapper6";
import Modalbox from "../utils/_modal-box";

var $ = jQuery;

export default class VideoModal extends Module {

	ready(app) {
		new Modalbox('.play-btn');
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_video-modal.js